import Config from "@/config";

export default {
    init() {
        return new Promise((resolve, reject) => {
            console.log("Enabling PUSH");
            // Проверяем поддержку API
            if ('serviceWorker' in navigator && 'PushManager' in window) {
                // Регистрируем Service Worker при загрузке страницы
                navigator.serviceWorker.register('/push-sw.js')
                    .then(registration => {
                        console.log('✅ Service Worker enabled:', registration);
                        resolve();
                    })
                    .catch(error => {
                        console.error('❌ Error while registering Service Worker:', error);
                        reject();
                    });
            } else {
                console.warn('⚠️ Service Worker / Web Push API is not supported');
                reject();
            }
        });
    },

    async obtainSubscription() {
        // Публичный VAPID ключ (не секретный, можно хранить в коде)
        const VAPID_PUBLIC_KEY = Config.VAPID_PUBLIC_KEY;

        console.log("Subscribing to push messaged, public key "+VAPID_PUBLIC_KEY);

        // Вспомогательная функция для конвертации Base64 в Uint8Array
        function urlBase64ToUint8Array(base64String) {
            const padding = '='.repeat((4 - base64String.length % 4) % 4);
            const base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');

            const rawData = window.atob(base64);
            const outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }

            return outputArray;
        }

        try {
            // Ждём, пока Service Worker будет готов
            console.log("Waiting for service...");
            const registration = await navigator.serviceWorker.ready;
            console.log("Service obtained!");

            // Запрашиваем разрешение у пользователя
            // ВАЖНО: это должно быть в ответ на действие пользователя (клик)
            const permission = await Notification.requestPermission();

            if (permission !== 'granted') {
                console.log('❌ Пользователь отклонил разрешение');
                return;
            }

            // Подписываем пользователя на push
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true, // Уведомления должны быть видны
                applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
            });

            console.log('✅ Пользователь подписан на уведомления');
            console.log('Subscription:', subscription);

            /*// Отправляем данные подписки на сервер
            await fetch('/api/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(subscription)
            });

            console.log('✅ Данные подписки отправлены на сервер');*/
            return subscription;

        } catch (error) {
            console.error('❌ Ошибка при подписке:', error);
        }
    }
}